import React from "react";
import WaveText from "../WaveText";

export default function GrammarRulesGeneratorPanel({
  showGrammarRulesGenerator, generatedGrammarRules, showAskMe, showTemplates,
  showWordDefinitionGenerator, showWordTranslationGenerator, showTrueFalseGenerator,
  showWarmUpDiscussionGenerator, showCreateDialogueGenerator, showEssentialVocabularyGenerator,
  showLeadInActivitiesGenerator, showFourOpinionsGenerator, showCommunicativeSituationsGenerator,
  showMatchingHalvesGenerator, showErrorCorrectionGenerator,
  grammarRulesInput, setGrammarRulesInput, grammarRulesLevel, setGrammarRulesLevel,
  grammarRulesLanguage, setGrammarRulesLanguage, grammarRulesLoading,
  handleGrammarRulesGenerate, handleGrammarRulesInsert, handleGrammarRulesCancel,
}) {
  if (!((showGrammarRulesGenerator || generatedGrammarRules) && !showAskMe && !showTemplates && !showWordDefinitionGenerator && !showWordTranslationGenerator && !showTrueFalseGenerator && !showWarmUpDiscussionGenerator && !showCreateDialogueGenerator && !showEssentialVocabularyGenerator && !showLeadInActivitiesGenerator && !showFourOpinionsGenerator && !showCommunicativeSituationsGenerator && !showMatchingHalvesGenerator && !showErrorCorrectionGenerator)) {
    return null;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, transition: 'opacity 0.22s, transform: 0.22s' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <button onClick={handleGrammarRulesCancel} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginRight: 4, transition: 'color 0.18s' }}>
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none"><path d="M12 16l-4-4 4-4" stroke="#8a2be2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>
        <span style={{ fontSize: 16, fontWeight: 600, color: '#22223b' }}>Generate Grammar Rules</span>
      </div>

      <textarea
        value={grammarRulesInput}
        onChange={e => setGrammarRulesInput(e.target.value)}
        placeholder="Describe the grammar topic you want to explain..."
        rows={4}
        style={{
          fontSize: 15,
          padding: '12px',
          borderRadius: 8,
          border: '1.5px solid #cfcfff',
          background: '#f7fbff',
          resize: 'vertical',
          fontFamily: 'Inter, Segoe UI, Arial, sans-serif',
          width: '100%',
          boxSizing: 'border-box'
        }}
      />

      <div style={{ display: 'flex', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
        <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 8, flex: '1 1 auto', minWidth: 0 }}>
          CEFR Level:
          <select
            value={grammarRulesLevel}
            onChange={e => setGrammarRulesLevel(e.target.value)}
            style={{
              fontSize: 14,
              padding: '6px 8px',
              borderRadius: 6,
              border: '1.5px solid #cfcfff',
              background: '#fff',
              cursor: 'pointer',
              flex: 1,
              minWidth: 0,
            }}
          >
            <option value="A1">A1 - Beginner</option>
            <option value="A2">A2 - Elementary</option>
            <option value="B1">B1 - Intermediate</option>
            <option value="B2">B2 - Upper Intermediate</option>
            <option value="C1">C1 - Advanced</option>
            <option value="C2">C2 - Mastery</option>
          </select>
        </label>
        <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 8, flex: '1 1 auto', minWidth: 0 }}>
          Language:
          <select
            value={grammarRulesLanguage}
            onChange={e => setGrammarRulesLanguage(e.target.value)}
            style={{
              fontSize: 14,
              padding: '6px 8px',
              borderRadius: 6,
              border: '1.5px solid #cfcfff',
              background: '#fff',
              cursor: 'pointer',
              flex: 1,
              minWidth: 0,
            }}
          >
            <option value="English">English</option>
            <option value="Russian">Russian</option>
            <option value="Armenian">Armenian</option>
            <option value="French">French</option>
            <option value="German">German</option>
            <option value="Spanish">Spanish</option>
            <option value="Italian">Italian</option>
            <option value="Chinese">Chinese</option>
            <option value="Japanese">Japanese</option>
            <option value="Korean">Korean</option>
            <option value="Portuguese">Portuguese</option>
            <option value="Turkish">Turkish</option>
            <option value="Georgian">Georgian</option>
            <option value="Persian">Persian</option>
            <option value="Arabic">Arabic</option>
            <option value="Ukrainian">Ukrainian</option>
            <option value="Polish">Polish</option>
            <option value="Romanian">Romanian</option>
            <option value="Bulgarian">Bulgarian</option>
            <option value="Greek">Greek</option>
            <option value="Serbian">Serbian</option>
            <option value="Croatian">Croatian</option>
            <option value="Bosnian">Bosnian</option>
            <option value="Slovenian">Slovenian</option>
            <option value="Macedonian">Macedonian</option>
            <option value="Albanian">Albanian</option>
            <option value="Hungarian">Hungarian</option>
            <option value="Czech">Czech</option>
            <option value="Slovak">Slovak</option>
            <option value="Dutch">Dutch</option>
            <option value="Swedish">Swedish</option>
            <option value="Norwegian">Norwegian</option>
            <option value="Finnish">Finnish</option>
            <option value="Danish">Danish</option>
          </select>
        </label>
      </div>

      <button
        onClick={handleGrammarRulesGenerate}
        disabled={grammarRulesLoading || !grammarRulesInput.trim()}
        className={grammarRulesLoading ? 'magic-generating-btn' : 'magic-btn'}
        style={{
          fontSize: 15,
          padding: '12px 16px',
          borderRadius: 8,
          border: 'none',
          background: !grammarRulesInput.trim() && !grammarRulesLoading ? '#e0e0e0' : grammarRulesLoading ? undefined : '#8a2be2',
          color: !grammarRulesInput.trim() && !grammarRulesLoading ? '#999' : '#fff',
          fontWeight: 600,
          cursor: grammarRulesLoading ? 'wait' : !grammarRulesInput.trim() ? 'not-allowed' : 'pointer',
          transition: 'all 0.2s',
          width: '100%',
        }}
      >
        {grammarRulesLoading ? <WaveText /> : 'Do the magic'}
      </button>

      {generatedGrammarRules && (
        <div style={{ marginTop: 12, padding: 12, background: '#f8f9fa', borderRadius: 8, border: '1px solid #e9ecef' }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: '#22223b', marginBottom: 8 }}>
            Generated: Grammar Rules
          </div>
          <div style={{ fontSize: 13, color: '#6c757d', marginBottom: 12 }}>
            Comprehensive grammar explanation ready
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              onClick={handleGrammarRulesInsert}
              className="magic-btn"
              style={{ fontSize: 14, padding: '8px 16px', borderRadius: 6, fontWeight: 600, cursor: 'pointer', width: '100%' }}
            >
              Add
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
